import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router'

import { Toast,Overlay,Loading,Uploader,Picker,Popup,Dialog,Icon  } from 'vant';
import 'vant/lib/index.css';
Vue.use(Toast);
Vue.use(Overlay);
Vue.use(Loading);
Vue.use(Uploader);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(Icon);


Vue.use(Router)
import router from './routers.js'
import '@/assets/global.less' /*引入公共样式*/
// import VConsole from 'vconsole'

// var vConsole = new VConsole()

// 基础组件的自动化全局注册。全局注册的行为必须在根 Vue 实例 (通过 new Vue) 创建之前发生
import './components/index';
import {parseQuery} from "@/utils";
import { getOrCreateUserId } from '@/utils/auth'



Vue.prototype.$toast=Toast



Vue.prototype.back=function () {
	if (window.history.length <= 1) {
	    this.$router.push({path:'/'})
	    return false
	} else {
	    this.$router.go(-1)
	}
}

Vue.prototype.openUrl=function (url) {
	this.$router.push({path:url})
	
}

const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

Vue.config.productionTip = false

// 初始化用户标识：微信环境走OAuth，非微信环境自动生成UUID
// 必须在 Vue 实例挂载之前执行，确保页面组件 mounted 时 localStorage 已有 openId
const userId = getOrCreateUserId()
if (!userId) {
  // getOrCreateUserId 内部会跳转微信OAuth，此处不会执行到
}

new Vue({
  render: h => h(App),
  router
}).$mount('#app')